<template>
  <div class="ml-4">
    <span v-if="!question.choices.hasExpectation"
      >R${{ formatCurrency(answer.choices.currency) }}</span
    >
    <div v-else-if="!question.choices.salaryRange">
      <span class="d-block"
        >Valor inserido pelo candidato(a): R$
        {{ formatCurrency(answer.choices.currency) }}</span
      >
      <span class="d-block"
        >Valor esperado: R$
        {{ formatCurrency(question.choices.expectedSalary.minValue) }}</span
      >
    </div>
    <div v-else>
      <span class="d-block"
        >Valor inserido pelo candidato(a): R$
        {{ formatCurrency(answer.choices.currency) }}</span
      >
      <span class="d-block"
        >Valor esperado: R$
        {{ formatCurrency(question.choices.expectedSalary.minValue) }}
        a R$
        {{ formatCurrency(question.choices.expectedSalary.maxValue) }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["answer"],
  computed: {
    question() {
      return this.answer.question;
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "BRL",
      })
        .format(value)
        .replace("R$", "")
        .trim();
    },
  },
};
</script>